import { Button } from '@/components/ui/button';
import {
  isRouteErrorResponse,
  useNavigate,
  useRouteError,
} from 'react-router-dom';

export function RootErrorBoundary() {
  const error = useRouteError();
  const navigate = useNavigate();

  if (isRouteErrorResponse(error)) {
    return (
      <>
        <h1>
          {error.status} {error.statusText}
        </h1>
        <p>{error.data}</p>
      </>
    );
  } else if (error instanceof Error) {
    return (
      <div className="grid place-items-center">
        <h1>Error</h1>
        <div>{error.message}</div>
        <div>
          <Button onClick={() => navigate('/')}>Вернуться на главную</Button>
        </div>
      </div>
    );
  } else {
    return (
      <div>
        <h1>Unknown Error</h1>
        <Button onClick={() => navigate('/')}>Вернуться на главную</Button>
      </div>
    );
  }
}
